import { resolveIdentifier, types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { PharmacyDetails } from './PharmacyDetails';
import { Pharmacy } from './Pharmacy';

export const SecretariatNeighbor = types.compose(
  BaseEntity,
  types
    .model('SecretariatNeighbor', {
      secretariatNeighborId: types.identifierNumber,
      secretariatId: types.number,
      pharmacyId: types.number
    })
    .views((self) => {
      return {
        get pharmacyDetails() {
          if (self.pharmacyId) {
            return resolveIdentifier(PharmacyDetails, self, self.pharmacyId);
          } else {
            return null;
          }
        },
        get pharmacySimple() {
          if (self.pharmacyId) {
            return resolveIdentifier(Pharmacy, self, self.pharmacyId);
          } else {
            return null;
          }
        },
      };
    })
);
